<template>
    <Carousel
        :key="forceUpdate"
        :class="bgClass"
    >
        <template #header>
            <div class="flex items-center">
                <span class="flex-initial icon icon-group w-8 h-8 mr-2"></span>
                <h2 class="flex-1 font-subtitle-3 md:font-subtitle-2 line-clamp-2 break-word-please">
                    {{ item.h2 }}
                </h2>
            </div>
        </template>
        <template #content>
            <Spinner
                v-if="loading"
                appearance="dots"
                class="mx-auto my-4"
                size="xs"
            />
        </template>
        <template #slides>
            <div
                v-for="group in item.data"
                :key="group.id"
                class="py-1"
            >
                <div class="bg-white w-80 pt-4 px-4 pb-2 shadow rounded-lg md:w-84">
                    <div class="mb-3">
                        <h3 class="h-12 text-blue-600 text-base font-normal leading-6 line-clamp-2 break-word-please">
                            <a
                                :href="group.link"
                                :alt="group.h3"
                            >
                                {{ group.h3 }}
                            </a>
                        </h3>
                    </div>
                    <div class="flex justify-end text-sm text-slate-400 leading-5 pt-2 border-t">
                        <div
                            v-if="group.posts !== undefined"
                            class="flex items-center ml-4"
                        >
                            <span class="icon icon-discussions h-5 w-5 mr-1"></span>
                            <span>{{ group.posts || 0 }}</span>
                        </div>
                        <div
                            v-if="group.users !== undefined"
                            class="flex items-center ml-4"
                        >
                            <span class="icon icon-users h-5 w-5 mr-1"></span>
                            <span>{{ group.users || 0 }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template #footer>
            <WidgetFooter
                :text="item.text"
                :button-link="item.button_link"
                :button-target="item.button_target"
                :button-text="item.button_text"
            ></WidgetFooter>
        </template>
    </Carousel>
</template>

<script>
import Carousel from '@/components/Carousel';
import WidgetFooter from './WidgetFooter.vue';

export default {
    name: 'GroupsWidget',
    components: {
        WidgetFooter,
        Carousel,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        bgClass: {
            type: String,
            default: 'bg-slate-50',
        },
    },
    data: () => ({
        forceUpdate: 1,
    }),
    watch: {
        'item.data': function itemData() {
            // carousel is unable to detect content change
            this.forceUpdate += 1;
        },
    },
};
</script>

<style lang="scss" scoped>
@screen md {
    .md\:w-84 {
        width: 21rem;
    }
}
</style>
